export default __webpack_public_path__ + "static/media/id-verifing.6d32eb1b.jpg";